/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';

import { GlobalContext } from './contexts';

import type { BaseCoreModule } from '../../../core-modules/base-core-module';
import type { GlobalContextData } from './interfaces';

export interface GlobalContextProviderProps<T extends BaseCoreModule<any>> {
    coreModule: T;
    children: React.ReactElement;
}

export const GlobalContextProvider: React.FC<GlobalContextProviderProps<any>> = observer(({ coreModule, children }) => {
    const globalContextData: GlobalContextData = useMemo(() => ({
        appState: coreModule.appState,
        strategy: coreModule.strategy,
        prefixes: coreModule.prefixes,

        getLoginPath: coreModule.getLoginPath,
        getPortalPath: coreModule.getPortalPath,
        setAppState: coreModule.setAppState.bind(coreModule),
        initApp: coreModule.init.bind(coreModule),
        logout: coreModule.logout.bind(coreModule),

        lang: coreModule.currentLang,
        routes: coreModule.userRoutes,
        suppliers: coreModule.getSuppliers(),
        services: coreModule.getServices(),

        appDataStore: coreModule.appDataStore,
        appStorage: coreModule.appStorage,
        addons: coreModule.addons,
        appEventHandlers: coreModule.appEventHandlers,
    }), [coreModule.appState, coreModule.appDataStore]);

    return (
        <GlobalContext.Provider value={globalContextData}>
            {children}
        </GlobalContext.Provider>
    );
});
